import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-3"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 col-md-9"
}
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = /*#__PURE__*/_createVNode("th", null, "Action", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 2,
  class: "col-12"
}
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table" }
const _hoisted_15 = /*#__PURE__*/_createVNode("th", null, "Status", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BstkCSVToggleHeaders = _resolveComponent("BstkCSVToggleHeaders")
  const _component_BstkCSVToggleCreateMissing = _resolveComponent("BstkCSVToggleCreateMissing")
  const _component_BstkCSVInput = _resolveComponent("BstkCSVInput")
  const _component_BstkCSVErrors = _resolveComponent("BstkCSVErrors")
  const _component_BstkCSVMap = _resolveComponent("BstkCSVMap")
  const _component_BstkCSVImport = _resolveComponent("BstkCSVImport")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode("div", _hoisted_2, [
      (_ctx.import_list.records.length < 1 && _ctx.import_list.errors.length < 1)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_BstkCSVImport, {
              modelValue: _ctx.csv_data,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.csv_data = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (_ctx.import_checked = 0))
              ],
              fields: _ctx.csv_fields,
              "onUpdate:modelMap": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateCsvMap($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BstkCSVToggleHeaders),
                _createVNode(_component_BstkCSVToggleCreateMissing),
                _createVNode(_component_BstkCSVInput),
                _createVNode(_component_BstkCSVErrors),
                _createVNode(_component_BstkCSVMap)
              ]),
              _: 1
            }, 8, ["modelValue", "fields"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.csv_data.length > 0 && _ctx.import_list.records.length < 1 && _ctx.import_list.errors.length < 1)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("table", _hoisted_6, [
                _createVNode("thead", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_fields, (field, index) => {
                    return (_openBlock(), _createBlock("th", { key: index }, _toDisplayString(field.label), 1))
                  }), 128)),
                  _hoisted_7
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_data, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_fields, (field, name) => {
                        return (_openBlock(), _createBlock("td", { key: name }, _toDisplayString(item[name]), 1))
                      }), 128)),
                      _createVNode("td", null, [
                        ('status' in item)
                          ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(item['status']), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_9, "-"))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.csv_data.length) + " records to import, " + _toDisplayString(_ctx.import_checked) + " checked, " + _toDisplayString(_ctx.import_list.to_change) + " changes, " + _toDisplayString(_ctx.import_list.to_add) + " additions. ", 1),
                _createVNode("button", {
                  class: "btn btn-outline-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkImport()))
                }, "Check import"),
                (_ctx.import_checked == _ctx.csv_data.length)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn btn-outline-primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.processImport()))
                    }, "Do import"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.import_list.records.length > 0 || _ctx.import_list.errors.length > 0 )
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("table", _hoisted_14, [
                _createVNode("thead", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_fields, (field, index) => {
                    return (_openBlock(), _createBlock("th", { key: index }, _toDisplayString(field.label), 1))
                  }), 128)),
                  _hoisted_15
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.import_list.records, (item, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: index,
                      class: item.message == 'Failed' ? 'alert-warning' : 'alert-success'
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_fields, (field, name) => {
                        return (_openBlock(), _createBlock("td", { key: name }, _toDisplayString(item[name]), 1))
                      }), 128)),
                      _createVNode("td", null, _toDisplayString(item.message), 1)
                    ], 2))
                  }), 128)),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.import_list.errors, (item, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: index,
                      class: "alert-warning"
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.csv_fields, (field, name) => {
                        return (_openBlock(), _createBlock("td", { key: name }, _toDisplayString(item[name]), 1))
                      }), 128)),
                      _createVNode("td", null, _toDisplayString(item.message), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}